module.exports = __webpack_public_path__ + "static/media/profile-1.e9ee0034.png";